<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
    <type-of-sale-choices-list-filter
      @edit="editComponentFilters($event, 'filter__type_of_sale')"
      @clean="cleanComponentFilters(['filter__type_of_sale'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as PRODUCT_CATEGORY_TYPES } from './store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'ProductCategoryCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: PRODUCT_CATEGORY_TYPES.GENERIC.product.productcategory.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...PRODUCT_CATEGORY_TYPES.GENERIC.product.productcategory.LIST.ACTIONS
    })
  }
}
</script>
